<div class="px-4 py-10">
    <form [formGroup]="form">
        <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input
                    matStartDate
                    formControlName="startDate"
                    placeholder="Start date" />
                <input
                    matEndDate
                    formControlName="endDate"
                    placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle
                matIconPrefix
                [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </form>
    <div class="mat-elevation-z3">
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
                <mat-cell
                    class="!py-4"
                    *matCellDef="let row">
                    <img
                        class="mr-4 size-12"
                        [src]="row.logoUrl"
                        alt="" />
                    <span>{{ row.title }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="platform">
                <mat-header-cell *matHeaderCellDef>Platform</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ row.platform | appFlagToString: Platform }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="billingType">
                <mat-header-cell *matHeaderCellDef>Billing type</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ BillingType[row.billingType] }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef>Price</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ row.price }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="earned">
                <mat-header-cell *matHeaderCellDef>Earned</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ row.usersEarned }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef>
                    {{ totalEarned() | number: "1.2-2" }}
                </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="revenue">
                <mat-header-cell *matHeaderCellDef>Revenue</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ row.revenue }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef>
                    {{ totalRevenue() | number: "1.2-2" }}
                </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="earningsPerClick">
                <mat-header-cell *matHeaderCellDef>EPC</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{ row.earningsPerClick }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns()"></mat-footer-row>
        </mat-table>
        <mat-paginator
            [pageSizeOptions]="[15, 30, 50]"
            showFirstLastButtons
            aria-label="Select page of periodic elements"></mat-paginator>
    </div>
</div>
